import React from 'react';
import { Users, Award, Shield, Target } from 'lucide-react';

const About = () => {
  const features = [
    {
      icon: <Users size={32} />,
      title: "Trusted Expertise",
      description: "Years of experience across investments, loans, and financial planning with proven results."
    },
    {
      icon: <Award size={32} />,
      title: "Personalized Service",
      description: "Tailored financial strategies that align with your unique goals and risk appetite."
    },
    {
      icon: <Shield size={32} />,
      title: "Integrity Driven",
      description: "Transparent, ethical practices that put your financial interests first, always."
    },
    {
      icon: <Target size={32} />,
      title: "Goal Focused",
      description: "Strategic planning that keeps your short-term and long-term objectives in clear sight."
    }
  ];

  return (
    <section id="about" className="section-padding bg-gradient-section">
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="heading-section fade-in-up">About NSA Financial Services</h2>
          <p className="text-large max-w-3xl mx-auto fade-in-up delay-1">
            Building wealth requires more than just market knowledge—it demands trust, strategy, and unwavering commitment to your success.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          {/* About Content */}
          <div className="fade-in-up">
            <h3 className="heading-card mb-6">
              Your Partner in Financial Growth & Assurance
            </h3>
            <div className="space-y-4 text-body">
              <p>
                In a time where financial markets are dynamic and unpredictable, you need a partner who combines expertise, ethics, and tailored strategy-building. NSA Financial Services, led by <strong>Nitu Arora</strong>, brings years of experience across investments, loans, mutual funds, and disciplined financial planning.
              </p>
              <p>
                Our philosophy is simple: your financial success is our primary mission. We believe that every client deserves personalized attention, transparent communication, and strategies that evolve with your changing needs and market conditions.
              </p>
              <p>
                Our goal: to guide you to your short-term and long-term financial milestones—with clarity, trust, and proven expertise that you can count on.
              </p>
            </div>
            
            <div className="mt-8 p-6 bg-light-gold rounded-2xl border-l-4 border-primary-gold">
              <p className="font-poppins font-medium text-primary-green">
                "We don't just manage your money—we partner with you to build the financial future you envision."
              </p>
              <p className="text-sm text-secondary mt-2">— Nitu Arora, Founder</p>
            </div>
          </div>

          {/* Features Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 fade-in-up delay-2">
            {features.map((feature, index) => (
              <div 
                key={index} 
                className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100"
              >
                <div className="text-primary-gold mb-4">
                  {feature.icon}
                </div>
                <h4 className="font-poppins font-semibold text-primary-green mb-3">
                  {feature.title}
                </h4>
                <p className="text-body text-sm">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Stats Section */}
        <div className="bg-white rounded-2xl p-8 shadow-xl fade-in-up delay-3">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="text-4xl font-bold text-primary-gold font-poppins mb-2">5+</div>
              <div className="text-secondary font-medium">Years of Experience</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-primary-gold font-poppins mb-2">100+</div>
              <div className="text-secondary font-medium">Satisfied Clients</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-primary-gold font-poppins mb-2">₹10Cr+</div>
              <div className="text-secondary font-medium">Assets Under Management</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-primary-gold font-poppins mb-2">50+</div>
              <div className="text-secondary font-medium">Investment Options</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;